class ImageTextSlider {
  constructor(parent) {
    if (parent.length === 0) {
      return
    }
    this.parent = parent;
    this.init();
  }

  swiper = () => {
    let parents = this.parent;
    parents.forEach(parent => {
      let swiperImage = document.querySelector('.image-text-slider-js', parent);
      if (!swiperImage) {
        return;
      }
      var swiper = new Swiper(swiperImage, {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
        },
        breakpoints: {
          767: {
            slidesPerView: 1,
            spaceBetween: 0
          }
        }
      });
    });
  }

  clickEvent = () => {
    document.addEventListener("click",(e) => {
      let that = e.target;
      if (that.closest(".text-icon-wrapper") || that.classList.contains("overlay-wrapper")) {
        document.body.classList.add("pop-enable-class");
        let clickIndex = that.closest(".banner-container").getAttribute('data-index');
        document.querySelector(".popup-data-wrapper").classList.remove("hide");
        document.querySelectorAll(".popup-data-wrapper .popup-image-detail-container")[clickIndex - 1];
        document.querySelectorAll(".popup-data-wrapper .popup-image-detail-container")[clickIndex - 1]?.classList?.remove("hide");
      } else if(!that.classList.contains("popup-image-detail-container") && that.classList.contains("popup-data-wrapper")) {
        document.body.classList.remove("pop-enable-class");
        let activeIndex = '';
        document.querySelectorAll(".popup-data-wrapper .popup-image-detail-container").forEach((div, index) => {
          if (!div.classList.contains('hide')) {
            activeIndex = index;
          }
        });
        document.querySelectorAll(".popup-data-wrapper .popup-image-detail-container")[activeIndex]?.classList?.add("hide");
        document.querySelector(".popup-data-wrapper").classList.add("hide");
      } else if(that.closest(".close-button") || that.classList.contains("close-button")) {
        document.body.classList.remove("pop-enable-class");
        let activeIndex = '';
        document.querySelectorAll(".popup-data-wrapper .popup-image-detail-container").forEach((div, index) => {
          if (!div.classList.contains('hide')) {
            activeIndex = index;
          }
        });
        document.querySelectorAll(".popup-data-wrapper .popup-image-detail-container")[activeIndex]?.classList?.add("hide");
        document.querySelector(".popup-data-wrapper").classList.add("hide");
      } else if(that.closest(".image-next-arrow")) {
        let nextIndex = that?.closest(".image-next-arrow")?.getAttribute('next-index');
        //add hide class to all div's
        document.querySelectorAll(".popup-data-wrapper .popup-image-detail-container").forEach((item,i)=>{
          item.classList.add('hide');
        });
        document.querySelectorAll(".popup-data-wrapper .popup-image-detail-container")[nextIndex - 1]?.classList?.remove('hide')
      } else if(that.closest(".image-previous-arrow")) {
        let nextIndex = that?.closest(".image-previous-arrow")?.getAttribute('previous-index');
        //add hide class to all div's
        document.querySelectorAll(".popup-data-wrapper .popup-image-detail-container").forEach((item,i)=>{
          item.classList.add('hide');
        });
        document.querySelectorAll(".popup-data-wrapper .popup-image-detail-container")[nextIndex - 1]?.classList?.remove('hide')
      }
    })
  }

  init = () => {
    this.swiper();
    this.clickEvent();
  }
  
}

document.addEventListener('DOMContentLoaded', () => {
  new ImageTextSlider(document.querySelectorAll('.denim-image-with-text-slider-conatiner'));
}, false);